import { useI18n } from '../i18n';

export default function LocaleSwitcher() {
  const { locale, setLocale } = useI18n();

  return (
    <div className="ep-locale-switcher">
      <button
        className={`ep-locale-btn${locale === 'fr' ? ' ep-locale-btn--active' : ''}`}
        onClick={() => setLocale('fr')}
        aria-label="Français"
      >
        FR
      </button>
      <span className="ep-locale-sep">|</span>
      <button
        className={`ep-locale-btn${locale === 'en' ? ' ep-locale-btn--active' : ''}`}
        onClick={() => setLocale('en')}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
}
